// RIADOK NAVYŠE — práca alebo materiál, ktoré vo výkaze výmer vôbec nie sú (Mirko 30. 9. 2026: „ak by niečo vyskočilo“).
// Ide vždy do bloku NAD RÁMEC ZoD — nepočíta sa do ceny diela ani do percenta čerpania, zmluvne sa rieši dodatkom.
// Prečo samostatné okno (navyse_v2, 30. 9. 2026): pôvodne to bolo päť window.prompt za sebou. Keď prehliadač raz dostane
// „Prevent this page from creating additional dialogues“, každý ďalší prompt vráti null a tlačidlo nerobí NIČ — bez hlášky.
// Ústava 131 aj tak žiada FormularV3, takže okno rieši oboje: funguje vždy a vyzerá ako zvyšok Matrixu.
import React, { useEffect, useMemo, useState } from 'react'
import FormularV3 from './FormularV3.jsx'
import { SearchableSelect } from './Ui.jsx'
import { TYPO, RADIUS } from '../theme.js'

const H = () => ({ Authorization: `Bearer ${localStorage.getItem('kamir_token') || ''}` })
const HJ = () => ({ ...H(), 'Content-Type': 'application/json' })
const num = (v) => { const n = parseFloat(String(v == null ? '' : v).replace(/\s/g, '').replace(',', '.')); return isFinite(n) ? n : 0 }
const f2 = (n) => (Number(n) || 0).toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const ymLabel = (ym) => { const [y, m] = String(ym || '').split('-'); return m && y ? `${m}/${y}` : ym }

const MJ = ['m²', 'm', 'bm', 'ks', 'kpl', 'h', 't', 'kg', 'l', 'deň']
// katalóg má jednotky písané po starom (m2, m3) — obrazovka ich ukazuje po slovensky
const naMJ = (u) => ({ m2: 'm²', M2: 'm²', m3: 'm³', M3: 'm³', mb: 'bm', hod: 'h' })[String(u || '').trim()] || (String(u || '').trim() || 'm²')

// ym = { key, year, month } — mesiac, do ktorého riadok patrí (obrazovka ho dodá, aj keď ho práve založila)
// uprava = { linka: {kluc, popis, mj, jc, dovod}, riadky: [{id, ym, zamknuty}] } — Mirko 30. 9. 2026:
// „možnosť upraviť text, množstvo, všetko čo bolo zadané“. Text, MJ, cena a dôvod sa menia na celej línii naraz;
// množstvo ostáva mesačné a mení sa priamo v Čerpaní. Odoslané (zamknuté) mesiace sa nedotknú — visia na nich faktúry a mzdy.
export default function RiadokNavyse({ projectId, ym, uprava = null, onZavri, onHotovo }) {
  const [chyba, setChyba] = useState('')
  // Mirko 30. 9. 2026: „ponúkaj položku z katalógu, katalóg si ukladá položky z CENKROSu; ak nebude, vlastná.“
  // Jeden register (0.J) — polozky_katalog, žiadny druhý zoznam položiek.
  const [katalog, setKatalog] = useState([])
  const [zKatalogu, setZKatalogu] = useState('')   // jednotka a cena predvyplnené z katalógu → povedz to pri poli
  const mes = ymLabel(ym && ym.key)
  const jeUprava = !!(uprava && uprava.linka)
  const meniSa = jeUprava ? uprava.riadky.filter(r => !r.zamknuty) : []
  const zamknute = jeUprava ? uprava.riadky.filter(r => r.zamknuty) : []

  useEffect(() => {
    let zive = true
    fetch('/api/polozky-katalog', { headers: H() })
      .then(r => (r.ok ? r.json() : []))
      .then(d => { if (zive) setKatalog(Array.isArray(d) ? d : []) })
      .catch(() => {})
    return () => { zive = false }
  }, [])

  const moznosti = useMemo(() => katalog.map(k => ({
    value: k.id,
    label: (k.cenkros_code ? k.cenkros_code + ' — ' : '') + String(k.description || '').replace(/\s+/g, ' ').slice(0, 110),
  })), [katalog])
  const jednotky = useMemo(() => [...new Set([...MJ, zKatalogu].filter(Boolean))], [zKatalogu])

  const kroky = [{
    id: 'riadok',
    nazov: jeUprava ? 'Upraviť riadok navyše' : 'Riadok navyše',
    hint: jeUprava
      ? `Popis, merná jednotka, cena aj dôvod sa zmenia vo všetkých mesiacoch tohto riadku (${meniSa.length}).` + (zamknute.length ? ` Odoslané mesiace (${zamknute.length}) sa nemenia — visia na nich faktúry a mzdy.` : '') + ' Množstvo za mesiac sa mení priamo v Čerpaní.'
      : `Práca alebo materiál mimo výkazu výmer — súpis ${mes}. Účtuje sa nad rámec ZoD podľa skutočnosti, zmluvne dodatkom.`,
    tlacidlo: jeUprava ? 'Uložiť zmenu' : 'Pridať do súpisu',
    sekcie: [{
      nazov: 'Čo sa urobilo navyše',
      polia: [
        {
          key: 'katalog', label: 'Položka z katalógu', sirka: 2,
          hint: katalog.length
            ? 'Katalóg drží položky z CENKROSu. Keď tam tvoja nie je, napíš ju sem a vyber „Použiť vlastný popis“ — text sa prenesie do popisu a ďalej sa dá prepísať.'
            : 'Katalóg je zatiaľ prázdny — napíš popis sem alebo rovno do poľa nižšie.',
          render: ({ hodnota, set }) => (
            <SearchableSelect value={hodnota || ''} onChange={set} options={moznosti} menuPortal
              allowCreate createLabel={(t) => 'Použiť vlastný popis: „' + t + '"'}
              placeholder={katalog.length ? 'Hľadať v katalógu, alebo rovno napíš vlastný popis…' : 'Napíš vlastný popis…'} />
          ),
          poZmene: (v, h, setViac) => {
            const k = katalog.find(x => String(x.id) === String(v))
            // Mirko 30. 9. 2026: „vlastný popis musí byť a musí sa dať editovať, nie iba zmazať.“ Čo napíšeš do
            // hľadania a v katalógu to nie je, sa rovno stane popisom — a ten sa ďalej normálne prepisuje.
            if (!k) {
              setZKatalogu('')
              const vlastny = String(v || '').trim()
              if (vlastny) setViac({ katalog: '', popis: vlastny })
              return
            }
            const j = naMJ(k.unit)
            setZKatalogu(j)
            setViac({
              katalog: v,
              popis: String(k.description || '').replace(/\s+/g, ' ').trim(),
              mj: j,
              cena_mj: (+k.typical_price > 0) ? String(k.typical_price).replace('.', ',') : (h.cena_mj || ''),
            })
          },
        },
        { key: 'popis', label: 'Popis práce alebo materiálu', povinne: true, sirka: 2, placeholder: 'napr. Prebrúsenie stien po inom dodávateľovi', hint: 'Z katalógu sa predvyplní, prepísať sa dá.' },
        { key: 'mj', label: 'Merná jednotka', typ: 'vyber', povinne: true, moznosti: jednotky.map(m => ({ value: m, label: m })) },
        { key: 'mnozstvo', label: 'Množstvo', typ: 'cislo', povinne: !jeUprava, skryt: () => jeUprava },
        { key: 'cena_mj', label: 'Jednotková cena v €', typ: 'cislo', povinne: true, hint: zKatalogu ? 'Z katalógu je to orientačná cena — over ju podľa poslednej faktúry.' : '' },
        {
          key: '_spolu', label: jeUprava ? 'Jednotková cena po zmene' : ('Spolu do súpisu ' + mes), sirka: 2, skryt: () => jeUprava,
          render: ({ hodnoty }) => (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: RADIUS.md, padding: '9px 12px' }}>
              <span style={{ fontSize: TYPO.sizes.sm, fontWeight: 700, color: '#b45309' }}>nad rámec ZoD — bez stropu, do ceny diela sa nepočíta</span>
              <b style={{ fontFamily: TYPO.mono, fontSize: TYPO.sizes.lg, color: '#b45309' }}>{f2(num(hodnoty.mnozstvo) * num(hodnoty.cena_mj))} €</b>
            </div>
          ),
        },
        {
          key: 'doKatalogu', label: 'Uložiť do katalógu', sirka: 2,
          skryt: (h) => jeUprava || !!h.katalog,
          hint: 'Vlastná položka sa nabudúce dá vybrať zo zoznamu ako každá položka z CENKROSu.',
          render: ({ hodnota, set, hodnoty }) => (
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: TYPO.sizes.sm, cursor: 'pointer' }}>
              <input type="checkbox" checked={!!hodnota} onChange={e => set(e.target.checked)} style={{ cursor: 'pointer' }} />
              <span>Pridať „{String(hodnoty.popis || '').trim() || 'túto položku'}" do katalógu položiek</span>
            </label>
          ),
        },
        { key: 'dovod', label: 'Odkiaľ to je', povinne: true, sirka: 2, placeholder: 'hlásenie zo stavby / dohoda so stavbyvedúcim / dodatok k ZoD', hint: 'Nech je o pol roka jasné, na základe čoho sa to fakturovalo.' },
      ],
    }],
    over: (h) => {
      const e = {}
      if (!String(h.popis || '').trim()) e.popis = 'Napíš, čo sa urobilo.'
      if (!jeUprava && num(h.mnozstvo) <= 0) e.mnozstvo = 'Množstvo musí byť väčšie ako nula.'
      if (num(h.cena_mj) < 0) e.cena_mj = 'Jednotková cena nemôže byť záporná.'
      if (!String(h.dovod || '').trim()) e.dovod = 'Napíš, odkiaľ to je — bez toho sa to o pol roka neobháji.'
      if (chyba) e._spolu = chyba
      return e
    },
  }]

  // Mirko 30. 9. 2026: „a možnosť [pri]čítať položku do katalógu vlastnú?“ — vlastná položka sa dá uložiť do
  // polozky_katalog, aby sa nabudúce dala vybrať. Jeden register (0.J), takže rovnaký popis sa druhýkrát nezaloží.
  const doKatalogu = async (h, cena) => {
    const popis = String(h.popis || '').trim()
    // už tam je → cieľ je splnený, netreba o tom nič hlásiť (jeden register, 0.J)
    const uz = katalog.find(k => String(k.description || '').trim().toLowerCase() === popis.toLowerCase())
    if (uz) return null
    try {
      const r = await fetch('/api/polozky-katalog', { method: 'POST', headers: HJ(), body: JSON.stringify({
        description: popis, unit: String(h.mj || 'm²').trim(), typical_price: cena, category: 'vlastné', cenkros_code: '', notes: '',
      }) })
      if (!r.ok) { const d = await r.json().catch(() => ({})); return 'Do katalógu sa to nepodarilo uložiť: ' + (d.error || ('HTTP ' + r.status)) }
      return null
    } catch (e) { return 'Do katalógu sa to nepodarilo uložiť: ' + (e && e.message ? e.message : '') }
  }

  const uloz = async (h) => {
    setChyba('')
    const mnozstvo = num(h.mnozstvo), cena = num(h.cena_mj)
    if (jeUprava) {
      const telo = { popis: String(h.popis || '').trim(), mj: String(h.mj || 'm²').trim(), cena_mj: cena, dovod: String(h.dovod || '').trim() }
      for (const r of meniSa) {
        try {
          const rr = await fetch('/api/supis-polozky/' + r.id, { method: 'PUT', headers: HJ(), body: JSON.stringify(telo) })
          if (!rr.ok) { const d = await rr.json().catch(() => ({})); const m = d.message || d.error || ('Nepodarilo sa uložiť (HTTP ' + rr.status + ').'); setChyba(m); alert(m); return false }
        } catch (e) { const m = 'Nepodarilo sa spojiť so serverom: ' + (e && e.message ? e.message : ''); setChyba(m); alert(m); return false }
      }
      if (onHotovo) await onHotovo()
      return true
    }
    try {
      const r = await fetch('/api/supis-polozky', {
        method: 'POST', headers: HJ(), body: JSON.stringify({
          projectId, year: ym.year, month: ym.month,
          popis: String(h.popis || '').trim(), mj: String(h.mj || 'm²').trim(),
          vymera: mnozstvo, cena_mj: cena, celkom: Math.round(mnozstvo * cena * 100) / 100,
          budget_item_id: '', typ: 'navyse', dovod: String(h.dovod || '').trim(),
        }),
      })
      if (!r.ok) {
        const d = await r.json().catch(() => ({}))
        const m = d.message || d.error || ('Nepodarilo sa uložiť (HTTP ' + r.status + ').')
        setChyba(m); alert(m)
        return false
      }
    } catch (e) {
      const m = 'Nepodarilo sa spojiť so serverom: ' + (e && e.message ? e.message : 'neznáma chyba')
      setChyba(m); alert(m)
      return false
    }
    if (!jeUprava && h.doKatalogu && !h.katalog) {
      const potiaz = await doKatalogu(h, cena)
      if (potiaz) alert(potiaz)   // riadok v súpise už je uložený, katalóg je len navyše — nezhadzuj kvôli nemu okno
    }
    if (onHotovo) await onHotovo()
    return true
  }

  return (
    <FormularV3
      open titul={(jeUprava ? 'Upraviť riadok navyše — ' : 'Riadok navyše — ') + mes} nazovZaznamu="riadok navyše" sirkaOkna="min(880px, 96vw)"
      kroky={kroky} pociatocne={jeUprava
        ? { katalog: '', popis: uprava.linka.popis || '', mj: uprava.linka.mj || 'm²', mnozstvo: '', cena_mj: String(uprava.linka.jc ?? '').replace('.', ','), dovod: uprava.linka.dovod || '', doKatalogu: false }
        : { katalog: '', popis: '', mj: 'm²', mnozstvo: '', cena_mj: '', dovod: '', doKatalogu: false }}
      onUloz={uloz} onZavri={onZavri}
    />
  )
}
